import React from 'react';

const NewsSection = () => {
  const documents = [
    {
      id: 1,
      title: "Kontrollen, Urteile und strukturelle Defizite im Spielerschutz",
      description: "Umfassende Analyse zu Kontrollen, Urteilen und strukturellen Defiziten im Spielerschutz. Ein wichtiges Dokument für Compliance-Verantwortliche und Branchenkenner.",
      url: "/pdfs/kontrollen-urteile-spielerschutz.pdf",
      size: "1.23 MB"
    },
    {
      id: 2,
      title: "Warum IDA in der Gastronomie unverzichtbar ist",
      description: "Erfahren Sie, wie IDA Gastronomiebetriebe dabei unterstützt, Compliance-Anforderungen zu erfüllen und gleichzeitig den Betrieb zu optimieren.",
      url: "/pdfs/ida-gastronomie.pdf",
      size: "0.95 MB"
    },
    {
      id: 3,
      title: "Legal - Illegal - Scheißegal",
      description: "Ein kritischer Blick auf die aktuelle Regulierung des Glücksspielmarktes in Deutschland. Warum wir jetzt gemeinsam den Schwarzmarkt zurückdrängen müssen. Und wie der Spagat zwischen mehr Produktfreiräumen und zugleich wirksamem Jugend- und Spielerschutz gelingen kann.",
      url: "/pdfs/legal-illegal-scheissegal.pdf",
      size: "1.05 MB"
    },
    {
      id: 4,
      title: "Problematisches Spielverhalten erkennen – bevor Spielen zum Problem wird",
      description: "Früherkennung von problematischem Spielverhalten ist entscheidend für effektiven Spielerschutz. Lernen Sie die Warnsignale zu erkennen und angemessen zu reagieren.",
      url: "/pdfs/problematisches-spielverhalten.pdf",
      size: "0.87 MB"
    },
    {
      id: 5,
      title: "Geldwäsche erkennen und richtig handeln",
      description: "Praxisnaher Leitfaden zur Erkennung von Geldwäsche-Verdachtsfällen und den korrekten Meldewegen. Essentielles Wissen für Compliance-Verantwortliche im Glücksspielbereich.",
      url: "/pdfs/geldwasche.pdf",
      size: "0.92 MB"
    }
  ];

  return (
    <section className="py-24 bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-3">
            News & Analysen
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-teal-700 to-blue-500 mx-auto mb-6"></div>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Aktuelle Einblicke, Analysen und Fachwissen aus der Glücksspielbranche
          </p>
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {documents.map((doc, index) => (
            <a
              key={doc.id}
              href={doc.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-white border border-gray-200 hover:border-teal-700 transition-all duration-300 hover:shadow-lg group relative overflow-hidden cursor-pointer"
            >
              <article className="p-8">
                {/* Article Header */}
                <div className="mb-4">
                  <div className="flex items-start justify-between mb-3">
                    <span className="text-sm font-medium text-teal-800 tracking-wider uppercase">
                      Fachartikel
                    </span>
                    <span className="text-sm text-gray-600 flex items-center gap-1">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                      {doc.size}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 leading-tight group-hover:text-teal-800 transition-colors">
                    {doc.title}
                  </h3>
                </div>

                {/* Article Description */}
                <p className="text-gray-700 leading-relaxed mb-6 line-clamp-3">
                  {doc.description}
                </p>

                {/* Download Link Text */}
                <div className="inline-flex items-center text-teal-800 font-medium">
                  <span>Dokument herunterladen</span>
                  <svg
                    className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </div>
              </article>

              {/* Subtle Bottom Border on Hover - Absolute positioned at bottom */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-teal-700 to-blue-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
            </a>
          ))}
        </div>

        {/* Optional: Archive Link */}
        <div className="text-center mt-12">
          <p className="text-gray-500 text-sm">
            Weitere Artikel und Analysen folgen in Kürze
          </p>
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
